import { RequestError } from '@townsquare/error-classes';
import { RestClient } from '@townsquare/rest-client';
import { createSearchParamsFromScratch } from '@townsquare/search-params';

import { Connector, TransitionTo } from './types';

const defaultConfig = {
	baseUrl: `/gateway/api/v4/teams/hris/org`,
};

class HRISClient extends RestClient {
	constructor(config = {}) {
		super({ ...defaultConfig, ...config });
	}

	async getAvailableConnectors(orgId: string, siteId: string) {
		return this.getResource<Connector[]>(`/${orgId}/site/${siteId}/connector/all`);
	}

	async getActiveConnector(orgId: string, siteId: string) {
		const queryParams = createSearchParamsFromScratch({ siteId }).toString();
		try {
			return await this.getResource<Connector>(`/${orgId}/connector?${queryParams}`);
		} catch (error) {
			if (error instanceof RequestError) {
				if (error.statusCode === 404) {
					return null;
				}
			}
			throw error;
		}
	}

	async setActiveConnector(orgId: string, siteId: string, connectorId: string) {
		return this.postResource<Connector, { siteId: string; connectorId: string }>(`/${orgId}/connector`, {
			siteId,
			connectorId,
		});
	}

	async removeActiveConnector(orgId: string, siteId: string, connectorId: string, transitionTo: TransitionTo) {
		const queryParams = createSearchParamsFromScratch({ siteId, transitionTo }).toString();
		return this.deleteResource(`/${orgId}/connector/${connectorId}?${queryParams}`);
	}
}

export default new HRISClient();
